import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "CDaught taught me that all behavior is communication. It is my job to interpret the cry.",
    name: "Tim Palmer",
    role: "Teacher",
    org: "Abilene ISD",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="eyebrow text-gold">Voices from the Field</div>
          <h2 className="font-serif text-4xl sm:text-5xl text-navy mt-3 font-bold tracking-tight">
            What educators are <span className="italic font-medium">saying.</span>
          </h2>
        </div>

        {TESTIMONIALS.map((t, i) => (
          <figure
            key={i}
            data-testid={`testimonial-${i}`}
            className="relative border-t border-b border-[hsl(var(--line))] py-14 md:py-20 text-center"
          >
            <Quote
              size={40}
              className="text-gold mx-auto mb-6"
              strokeWidth={1.2}
            />
            <blockquote
              data-testid={`testimonial-quote-${i}`}
              className="font-serif text-3xl md:text-4xl lg:text-[44px] text-navy leading-[1.2] font-medium tracking-tight max-w-3xl mx-auto"
            >
              &ldquo;{t.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-8 flex flex-col items-center">
              <span className="w-12 h-px bg-gold mb-4" />
              <span className="text-[15px] font-semibold text-navy" data-testid={`testimonial-name-${i}`}>
                {t.name}
              </span>
              <span className="text-[12px] tracking-[0.18em] uppercase text-navy/55 mt-1">
                {t.role} · {t.org}
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
